import { VerificationEditingRequest } from "models";

import type { ButtonType } from "components";

export interface EditingRequestButtonState {
  text: string;
  type: ButtonType;
  className: string;
}

/**
 * Determines the button state for editing request buttons based on the status of editing requests
 * @param editingRequests - Array of verification editing requests
 * @returns Button state configuration including text, type, and className
 */
export const getEditingRequestButtonState = (editingRequests: VerificationEditingRequest[]): EditingRequestButtonState => {
  if (editingRequests.length === 0) {
    return {
      text: "New request",
      type: "secondary",
      className: "editing-request-button",
    };
  }

  const hasUncompletedRequests = editingRequests.some((req) => !req.completedAt);
  const hasUnreviewedRequests = editingRequests.some((req) => req.completedAt && !req.reviewedAt);

  if (hasUncompletedRequests) {
    return {
      text: "View Request",
      type: "primary",
      className: "editing-request-button",
    };
  }

  if (hasUnreviewedRequests) {
    return {
      text: "Review request",
      type: "primary",
      className: "editing-request-review-button",
    };
  }

  return {
    text: "New request",
    type: "secondary",
    className: "editing-request-button",
  };
};
